/**
 * The decision target of the verification and product-review queues (ADM-2, card 117): 24 hours, set by the owner on
 * 2026-10-27. In its last 4 hours a case is due soon, and past it overdue; both need attention.
 */
export const DECISION_TARGET_HOURS = 24;
export const DUE_SOON_HOURS = 4;

const HOUR = 3_600_000;

export type TargetState =
  /** The clock has not started: for verification, the review has not (Sumsub has not answered yet). */
  | { readonly kind: "notStarted" }
  | { readonly kind: "within"; readonly waited: number; readonly left: number }
  | { readonly kind: "dueSoon"; readonly waited: number; readonly left: number }
  | { readonly kind: "overdue"; readonly waited: number };

/**
 * Where a case stands against the target, from when its clock started; whole hours waited (rounded down) and left
 * (rounded up, so a case is never shown "0 h left" before it is overdue).
 */
export function targetState(startedAt: string | null | undefined, now = Date.now()): TargetState {
  if (startedAt === null || startedAt === undefined) return { kind: "notStarted" };
  const elapsed = Math.max(0, now - new Date(startedAt).getTime());
  const waited = Math.floor(elapsed / HOUR);
  const remaining = DECISION_TARGET_HOURS * HOUR - elapsed;
  if (remaining <= 0) return { kind: "overdue", waited };
  const left = Math.ceil(remaining / HOUR);
  return left <= DUE_SOON_HOURS ? { kind: "dueSoon", waited, left } : { kind: "within", waited, left };
}

/** Whether a case needs attention: due soon or overdue. */
export const needsAttention = (state: TargetState) => state.kind === "dueSoon" || state.kind === "overdue";
